import PropTypes from 'prop-types';
import { Card, Typography } from '@material-ui/core';

// Single labelled stat tile. Used by both the team-scoped and
// company-wide deployment views to render the Part Number / Total
// Quantity / Monthly Peak Usage / Part Number Description cards
// in the same way — the chrome (label styling, padding, value weight)
// is owned here so callers only supply the label and value.
KpiCard.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  emphasized: PropTypes.bool,
  valueVariant: PropTypes.string
};

export default function KpiCard({ label, value, emphasized, valueVariant = 'h6' }) {
  return (
    <Card variant="outlined" sx={{ padding: 2, minWidth: 0, overflowWrap: 'anywhere' }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase' }}>
        {label}
      </Typography>
      <Typography
        variant={valueVariant}
        sx={{ mt: 1, fontWeight: 600, color: emphasized ? 'primary.main' : 'inherit' }}
      >
        {value}
      </Typography>
    </Card>
  );
}
